import {useContext} from 'react';

import {UseOfContextWithoutProviderError} from '@/types/errors';
import {DocumentContext} from './document-context';

export const useDocumentContext = () => {
  const context = useContext(DocumentContext);

  if (!context) {
    throw new UseOfContextWithoutProviderError('DocumentContext');
  }

  return context;
};
